module.exports = __webpack_public_path__ + "static/media/creativ2.7fbeac2a.jpg";